export default "__VITE_ASSET__CH5bVCW4__"